module.exports = {"id":"dp4_2l3q3","text":"Protecting personal data and privacy","instructions":"What is the main purpose of an online privacy policy?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"PickOne","random":true,"options":[{"id":"dp4_2l3q3-a1","text":"Explain data handling practices","score":3.7},{"id":"dp4_2l3q3-a2","text":"Advertise digital services","score":1.3},{"id":"dp4_2l3q3-a3","text":"Limit user access rights","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l3q3.json
// module id = 1230
// module chunks = 41